import React from 'react';

const ConfirmationModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="mb-4">{message}</p>
        {onConfirm ? (
          <div className="flex justify-end space-x-2">
            <button onClick={onClose} className="btn-outline">
              {cancelText}
            </button>
            <button
              onClick={() => {
                onConfirm();
              }}
              className="btn-primary"
            >
              {confirmText}
            </button>
          </div>
        ) : (
          <div className="text-right">
            <button onClick={onClose} className="btn-outline">
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationModal;
